var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserReviewProfilImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.559814,
    width: 35.9333,
    height: 35.9333,
    rx: 17.9667,
    fill: "#FFE9EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9698 19.0879C19.8271 19.0879 21.3385 17.5764 21.3385 15.7191V14.0348C21.3385 12.1775 19.8271 10.666 17.9698 10.666C17.0766 10.667 16.2204 11.0222 15.5888 11.6538C14.9573 12.2853 14.602 13.1416 14.601 14.0348V15.7191C14.601 17.5764 16.1125 19.0879 17.9698 19.0879Z",
    fill: "#E33745"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7771 20.772H15.1625C13.8227 20.7732 12.5381 21.3059 11.5907 22.2533C10.6433 23.2007 10.1106 24.4853 10.1094 25.8251C10.1094 26.135 10.3609 26.3866 10.6708 26.3866H25.2688C25.4177 26.3866 25.5605 26.3274 25.6658 26.2221C25.7711 26.1168 25.8302 25.974 25.8302 25.8251C25.829 24.4853 25.2963 23.2007 24.3489 22.2533C23.4015 21.3059 22.1169 20.7732 20.7771 20.772Z",
    fill: "#E33745"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserReviewProfilImg);
export default __webpack_public_path__ + "static/media/userReviewProfilImg.7a740045caa2a18ce2f95e8440b9356f.svg";
export { ForwardRef as ReactComponent };